import {useNavigate} from 'react-router';
import {useOrders} from '../executions/useOrders';
import {ORDER_ENTRY_PATH} from '../../constants/RoutesPaths'

export const useActionButtons = () => {
    const {
        handleShowOrder,
        handleViewPic,
        modalContent,
        showModalInformation,
        modalSize,
        modalBodyClass,
        modalFooter,
        modalTitle,
        buttons,
        setShowModalInformation,
        handleDeleteOrder,
        handleViewSav
    } = useOrders();
    const navigate = useNavigate();

    function handleEditOrder(order) {
        navigate(ORDER_ENTRY_PATH, {state: {order}})
    }

    const actionButtons = [
        {
            name: 'Visualiser',
            nameParam: 'numcde',
            color: 'primary',
            icon: 'eye',
            iconColor: 'white',
            classnames: 'm-1 padding-icon',
            func: handleShowOrder,
            funcParam: ['numcde', 'idsgribouil'],
            filter: 'actions',
            filterParam: 'visu',
        },
        {
            name: 'Voir les photos',
            color: 'primary',
            icon: 'image',
            iconColor: 'white',
            classnames: 'm-1',
            func: handleViewPic,
            filter: 'actions',
            filterParam: 'view_pic',
        },
        {
            name: 'Créer un dossier SAV',
            color: 'primary',
            icon: 'file-contract',
            iconColor: 'white',
            iconClassNames: 'margin-icon',
            classnames: 'm-1',
            func: handleViewSav,
            funcParam: ['numcde', 'recla_idx'],
            filter: 'actions',
            filterParam: 'sav_creat',
        },
        {
            name: 'Modifier un dossier SAV',
            color: 'primary-dark',
            icon: 'file-signature',
            iconColor: 'white',
            classnames: 'm-1 padding-icon',
            func: handleViewSav,
            funcParam: ['numcde', 'recla_idx'],
            filter: 'actions',
            filterParam: 'sav_view',
        },
    ]

    const actionPendingButtons = [
        {
            name: 'Modifier la commande',
            color: 'primary',
            icon: 'pen',
            iconColor: 'white',
            classnames: 'm-1 padding-icon',
            func: handleEditOrder,
        },
        {
            name: 'Supprimer la commande',
            color: 'red',
            icon: 'trash',
            iconColor: 'white',
            classnames: 'm-1',
            func: handleDeleteOrder,
        },
    ]

    return {
        actionButtons,
        actionPendingButtons,
        handleShowOrder,
        modalContent,
        showModalInformation,
        modalSize,
        modalBodyClass,
        modalFooter,
        modalTitle,
        buttons,
        setShowModalInformation,
    }
}
